export default "__VITE_ASSET__B1G9fnj7__"